import { useMessages } from '~/hooks/conversation'

export function useTaskBlock() {
  const messages = useMessages()
  const taskMessage = messages.find(message => message.blocks?.[0]?.type === 'task')
  return taskMessage?.blocks?.[0]
}
